/* NZS-LBX-1002: full-screen product image lightbox, ported from WAVY (assets/wavy-lightbox.js, WAVY-JADE-0926)
   to the Eurus PDP. Markup: sections/nzs-pdp-enhance.liquid renders dialog[data-nzs-lbx] when the section's
   "lightbox_v2" setting is on (per template). Styles: assets/nzs-lightbox.css.
   Opens from a tap on a gallery photo ([aria-label="zoom-image"][data-type="image"]) or the floating spyglass
   ([data-nzs-spyglass], the one magnifier on phones). The listener is WINDOW capture-phase, so it runs before
   nzs-pdp-enhance.js's document-capture lightbox and Alpine's zoomOpen; anything this dialog does not own
   (video, 3D, quick view, other products) falls through to them untouched.
   Enter transitions start from a forced reflow, never requestAnimationFrame. */
(function () {
  'use strict';
  if (window.nzsLbx) return;

  var OPEN = 'is-open';
  var CLOSE_MS = 240; // matches the .24s exit in nzs-lightbox.css
  var FADE_MS = 240; // image-to-image crossfade
  var DRIFT = 14; // px an image drifts during a button or key change
  var SWIPE_DRIFT = 28; // px it carries on after a committed swipe
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var st = null; // state of the open lightbox
  var drag = null;
  var dragEndAt = 0;
  var pd = { x: 0, y: 0 };

  function motion() { return !reduce.matches; }
  function reflow(el) { return el.getBoundingClientRect(); }
  function arr(list) { return Array.prototype.slice.call(list); }
  function mid(v) { v = String(v || ''); return v.slice(v.lastIndexOf('-') + 1); } // "<section id>-<media id>" -> media id
  function imgFor(dlg, id) { return dlg.querySelector('.nzs-lbx__img[data-media="' + id + '"]'); }
  function sidOf(pm) { return pm.id.replace('product-media-', ''); }

  /* The dialog renders inside the PDP Enhance section; it moves to <body> on first open so no transformed or hidden
     ancestor can trap it. A theme-editor re-render leaves a stale copy behind: drop it. */
  function dialog() {
    var all = arr(document.querySelectorAll('dialog[data-nzs-lbx]'));
    if (!all.length) return null;
    var dlg = all.filter(function (d) { return d.parentElement !== document.body; })[0] || all[all.length - 1];
    all.forEach(function (d) { if (d !== dlg && !d.open) d.remove(); });
    if (typeof dlg.showModal !== 'function') return null; // no <dialog> support: the old lightbox takes over
    if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
    bind(dlg);
    return dlg;
  }

  /* Lightbox order = the gallery's thumbnail rail (the same order on desktop and phone); single-image products have
     no rail, so fall back to the slides. Media the dialog has no photo for (video, 3D) is skipped. */
  function order(pm, dlg) {
    var rail = pm.querySelector('[data-nzs-gthumbs]');
    var els = rail ? rail.querySelectorAll('.nzs-gthumb[data-media-id]') : pm.querySelectorAll('[aria-label="zoom-image"][data-media-id]');
    var ids = [];
    arr(els).forEach(function (el) {
      var id = mid(el.getAttribute('data-media-id'));
      if (id && ids.indexOf(id) < 0 && imgFor(dlg, id)) ids.push(id);
    });
    return ids;
  }

  /* The photo in view: the rail's active thumb (kept in sync by the gallery controller on both layouts). */
  function currentId(pm) {
    var on = pm.querySelector('.nzs-gthumb.is-on[data-media-id]');
    if (on) return mid(on.getAttribute('data-media-id'));
    var first = pm.querySelector('[aria-label="zoom-image"][data-media-id]');
    return first ? mid(first.getAttribute('data-media-id')) : '';
  }

  /* NZS locks <html> (nzs-base.css html.nzs-lb-open{overflow:hidden}, shared with the old lightbox): html has
     overflow-x:clip, so a body lock would never reach the viewport, and html's stable gutter means nothing shifts. */
  function lockScroll() { document.documentElement.classList.add('nzs-lb-open'); }
  function unlockScroll() { document.documentElement.classList.remove('nzs-lb-open'); }

  function open(pm, id, opener, fromSpy) {
    var dlg = dialog();
    if (!dlg) return false;
    if (dlg.open) return true;
    var ids = order(pm, dlg);
    var start = ids.indexOf(id);
    if (start < 0 && fromSpy && ids.length) start = 0; // spyglass on a video/3D slide: open on the first photo
    if (start < 0) return false;
    try { if (window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('lightbox'); } catch (err) { /* other surfaces only */ }

    st = {
      dlg: dlg,
      pm: pm,
      opener: opener,
      spy: fromSpy,
      order: ids,
      imgs: arr(dlg.querySelectorAll('.nzs-lbx__img')),
      status: dlg.querySelector('[data-nzs-lbx-status]'),
      of: dlg.getAttribute('data-of') || 'of',
      i: -1,
      cur: null,
      returnTo: null,
      closing: false,
      closeTimer: 0,
      sweepTimer: 0
    };
    st.imgs.forEach(reset);
    if (ids.length < 2) dlg.setAttribute('data-single', '');
    else dlg.removeAttribute('data-single');
    show(start, 0, 0); // dialog still closed: no transition, the photo is simply there

    lockScroll();
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    dlg.classList.remove(OPEN);
    dlg.showModal(); // focuses the autofocus close button
    reflow(dlg);
    dlg.classList.add(OPEN); // fade + scale .97 -> 1 over .42s
    return true;
  }

  function reset(img) {
    img.hidden = true;
    img.classList.remove('is-current');
    img.style.transform = '';
    img.style.transition = '';
  }

  /* dir: +1 next, -1 previous, 0 no motion. fromDx: where a committed swipe left the old photo. */
  function show(i, dir, fromDx) {
    var n = st.order.length;
    i = ((i % n) + n) % n;
    var next = imgFor(st.dlg, st.order[i]);
    var prev = st.cur;
    if (!next) return;
    st.i = i;

    next.loading = 'eager';
    [i - 1, i + 1].forEach(function (k) {
      var near = imgFor(st.dlg, st.order[((k % n) + n) % n]);
      if (near) near.loading = 'eager'; // warm the neighbours so the next crossfade is instant
    });
    if (st.status) st.status.textContent = (i + 1) + ' ' + st.of + ' ' + n;
    if (next === prev) return;

    var animate = dir !== 0 && motion() && st.dlg.open;
    var drift = fromDx ? SWIPE_DRIFT : DRIFT;
    clearTimeout(st.sweepTimer);

    next.hidden = false;
    if (animate) {
      next.style.transition = 'none';
      next.style.transform = 'translateX(' + dir * drift + 'px)';
      reflow(next);
      next.style.transition = '';
      next.style.transform = '';
    }
    next.classList.add('is-current');
    if (prev) {
      prev.classList.remove('is-current');
      prev.style.transition = '';
      prev.style.transform = animate ? 'translateX(' + ((fromDx || 0) - dir * drift) + 'px)' : '';
    }
    st.cur = next;
    st.sweepTimer = setTimeout(sweep, animate ? FADE_MS + 40 : 0);
  }

  function sweep() {
    if (!st) return;
    st.imgs.forEach(function (img) { if (img !== st.cur) reset(img); });
  }

  function step(d) {
    if (!st || st.closing || st.order.length < 2) return;
    show(st.i + d, d, 0);
  }

  /* Put the gallery on the photo last viewed, so the lightbox fades out onto the same image. Phones: jump the
     native strip (instant). Desktop: the gallery controller's own activate (stage + rail). Returns the element that
     gets focus back: the spyglass if that opened it, else the photo's zoom button. */
  function landOn(s) {
    var target = s.opener;
    var id = s.order[s.i];
    if (!id || !s.pm.isConnected) return target;
    var sid = sidOf(s.pm);
    var full = sid + '-' + id;
    var track = s.pm.querySelector('.nzs-native-gallery .splide__track');
    var btn = null;
    if (track && track.clientWidth && track.scrollWidth > track.clientWidth + 1) {
      var li = track.querySelector('.splide__list > [data-media-id="' + full + '"]');
      if (li) {
        track.style.scrollBehavior = 'auto'; // this move must be instant
        track.scrollLeft = li.offsetLeft - li.parentElement.firstElementChild.offsetLeft;
        track.style.scrollBehavior = '';
        btn = li.querySelector('[aria-label="Image zoom"]');
      }
    } else {
      var act = window.__nzsGalActivate && window.__nzsGalActivate[sid];
      if (typeof act === 'function') act(full);
      btn = s.pm.querySelector('.product-media-item[data-media-id="' + full + '"] [aria-label="Image zoom"]');
    }
    if (!s.spy && btn && btn.getClientRects().length) target = btn;
    return target;
  }

  function close() {
    if (!st || st.closing || !st.dlg.open) return;
    var dlg = st.dlg;
    st.closing = true;
    drag = null;
    st.returnTo = landOn(st);
    dlg.classList.remove(OPEN); // .24s exit curve
    st.closeTimer = setTimeout(function () { if (dlg.open) dlg.close(); }, motion() ? CLOSE_MS : 0);
  }

  /* Runs on the dialog's native "close" (our timer, or the browser closing it directly, e.g. Android back). */
  function finish(dlg) {
    unlockScroll();
    dlg.classList.remove(OPEN);
    if (!st || st.dlg !== dlg) return;
    var s = st;
    st = null;
    drag = null;
    clearTimeout(s.closeTimer);
    clearTimeout(s.sweepTimer);
    var target = s.returnTo || landOn(s);
    if (target && target.isConnected) {
      try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
    }
  }

  function onKey(e) {
    if (!st) return;
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      step(1);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      step(-1);
    } else if (e.key === 'Tab') {
      // Keep focus on the three buttons.
      var f = arr(st.dlg.querySelectorAll('.nzs-lbx__btn')).filter(function (b) { return b.getClientRects().length > 0; });
      if (!f.length) return;
      var a = document.activeElement;
      var inside = f.indexOf(a) > -1;
      if (e.shiftKey && (!inside || a === f[0])) {
        e.preventDefault();
        f[f.length - 1].focus();
      } else if (!e.shiftKey && (!inside || a === f[f.length - 1])) {
        e.preventDefault();
        f[0].focus();
      }
    }
  }

  /* Touch swipe: the photo follows the finger, then crossfades on, or springs back. Mouse uses the buttons. */
  function onDown(e) {
    if (!st || st.closing || e.pointerType === 'mouse' || !e.isPrimary) return;
    drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: e.timeStamp, dx: 0, axis: '' };
  }
  function onMove(e) {
    if (!drag || !st || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x;
    var dy = e.clientY - drag.y;
    if (!drag.axis) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (drag.axis === 'x' && st.order.length > 1) {
        try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) { /* capture is a nicety */ }
        st.cur.style.transition = 'none';
      }
    }
    if (drag.axis !== 'x' || st.order.length < 2) return;
    drag.dx = dx;
    st.cur.style.transform = 'translateX(' + dx + 'px)';
  }
  function onUp(e) {
    if (!drag || e.pointerId !== drag.id) return;
    var d = drag;
    drag = null;
    if (d.axis !== 'x' || !st || st.order.length < 2) return;
    dragEndAt = Date.now();
    var dist = Math.abs(d.dx);
    var fast = dist > 24 && dist / Math.max(1, e.timeStamp - d.t) > 0.45;
    if (e.type === 'pointerup' && !st.closing && (dist > 56 || fast)) {
      var dir = d.dx < 0 ? 1 : -1;
      show(st.i + dir, dir, d.dx);
    } else {
      st.cur.style.transition = '';
      st.cur.style.transform = '';
    }
  }

  function bind(dlg) {
    if (dlg.hasAttribute('data-nzs-bound')) return;
    dlg.setAttribute('data-nzs-bound', '');
    var stage = dlg.querySelector('[data-nzs-lbx-stage]');
    var prev = dlg.querySelector('[data-nzs-lbx-prev]');
    var next = dlg.querySelector('[data-nzs-lbx-next]');
    var shut = dlg.querySelector('[data-nzs-lbx-close]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (shut) shut.addEventListener('click', close);
    dlg.addEventListener('cancel', function (e) {
      e.preventDefault(); // Escape / Android back: animate out instead of vanishing
      close();
    });
    dlg.addEventListener('close', function () { finish(dlg); });
    dlg.addEventListener('keydown', onKey);
    dlg.addEventListener('click', function (e) {
      if (Date.now() - dragEndAt < 400) return; // the click a swipe leaves behind
      var t = e.target;
      if (t && t.closest && t.closest('.nzs-lbx__img, .nzs-lbx__btn')) return;
      close(); // a tap on the empty space around the photo
    });
    if (stage) {
      stage.addEventListener('pointerdown', onDown);
      stage.addEventListener('pointermove', onMove);
      stage.addEventListener('pointerup', onUp);
      stage.addEventListener('pointercancel', onUp);
    }
  }

  /* Window capture phase: runs before the old lightbox (document capture) and Alpine's @click zoomOpen. */
  window.addEventListener('pointerdown', function (e) { pd.x = e.clientX; pd.y = e.clientY; }, true);
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var pm, id, opener;
    var sg = t.closest('[data-nzs-spyglass]');
    if (sg) {
      pm = document.getElementById('product-media-' + sg.getAttribute('data-nzs-spyglass'));
      if (!pm) return;
      id = currentId(pm);
      opener = sg;
    } else {
      var btn = t.closest('[aria-label="Image zoom"]');
      var slide = btn && btn.closest('[aria-label="zoom-image"][data-type="image"]');
      if (!slide) return;
      // A click that drifted >10px from its pointerdown is the tail of a gallery swipe, not a tap (NZS-LB-DRAGGUARD).
      if (e.detail !== 0 && (Math.abs(e.clientX - pd.x) > 10 || Math.abs(e.clientY - pd.y) > 10)) return;
      pm = slide.closest('[id^="product-media-"]');
      if (!pm) return;
      id = mid(slide.getAttribute('data-media-id'));
      opener = btn;
    }
    if (!open(pm, id, opener, !!sg)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  window.nzsLbx = { close: close };
})();
